import { withInstall } from '../../utils/install';

import Tree from './index.vue';

export const IvueTree = withInstall(Tree);
export default IvueTree;

export * from './index.vue';
